








import { Prop, Component,  Vue } from 'vue-property-decorator'
import { PieChart } from 'vue-chart-3'
import { Chart, ChartData, ChartOptions, PieController, ArcElement, Legend, Tooltip } from 'chart.js'
Chart.register(PieController, ArcElement, Legend, Tooltip)

@Component({
    components: {
        PieChart,
    },
})
export default class ChartPie extends Vue {
    @Prop({ default: () => [] }) readonly data!: ChartData
    @Prop({ default: () => [] }) readonly options!: ChartOptions<'pie'>
    @Prop({ default: () => [] }) readonly plugins!: object[]

    get chartOptions(): ChartOptions<'pie'> {
        return Object.assign({
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                easing: 'easeOutExpo',
            },
            plugins: {
                legend: {
                    position: 'right',
                },
                tooltip: {
                    backgroundColor: '#1e2a46',
                    titleFontSize: 18,
                    titleFontStyle: 'bold',
                    bodyFontSize: 18,
                    bodySpacing: 9,
                    xPadding: 9,
                    yPadding: 9,
                    caretSize: 16,
                },
            },
        }, this.options)
    }
}
